import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppState } from '../types/store';
import { getModuleMeta } from '../redux/selectors/modules';
import { updateModule } from '../redux/actions/modules';
import { useGruser } from './useGruser';

export const useModuleMeta = (moduleId: number) => {
  const { gruser } = useGruser();
  const dispatch = useDispatch();
  const moduleMeta = useSelector((state: AppState) =>
    getModuleMeta(state, gruser, moduleId)
  );

  const updateModuleMeta = useCallback(
    (meta: any) =>
      dispatch(updateModule(gruser!, { id: moduleId, moduleMeta: meta })),
    [dispatch, gruser, moduleId]
  );
  return { moduleMeta, updateModuleMeta };
};

export default useModuleMeta;
